    <template>
  <v-container fluid class="pl-15 pr-10">
    <AuthCtrl :parm_step="12"></AuthCtrl>
    <div class="d-flex justify-space-between mt-10 mb-5">
      <v-btn-toggle mandatory borderless color="blue">
        <v-btn height="36" small exact @click="onclickbtn(1)">
          <span class="text-capitalize font-weight-bold titleText--text"
            >Summary statistics</span
          >
        </v-btn>
        <v-btn height="36" small exact @click="onclickbtn(3)">
          <span class="text-capitalize font-weight-bold titleText--text"
            >ROI & Volume response</span
          >
        </v-btn>
        <v-btn height="36" small exact @click="onclickbtn(4)">
          <span class="text-capitalize font-weight-bold titleText--text"
            >Synergy b/w Activities</span
          >
        </v-btn>
      </v-btn-toggle>
      <v-btn
        v-if="this.isregiosubnnational && bttype === 1"
        right
        style="margin-left: 10px !important"
        class="runmodelbtn font-weight-bold text-capitalize white--text"
        depressed
        @click="OpenCtrlModelDataRegionWise()"
        >Region View</v-btn
      >
      <v-btn
        v-if="this.isregiosubnnational && bttype === 3"
        right
        style="margin-left: 10px !important"
        class="runmodelbtn font-weight-bold text-capitalize white--text"
        depressed
        @click="OpenCtrlModelDataRegionWiseMap()"
        >Region View</v-btn
      >
    </div>
    <div v-if="bttype === 1">
      <div class="d-flex">
        <h2 class="titleText--text">Model parameters</h2>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
            size="medium"
            v-bind="attrs"
            v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
          </template>
          <span>Model parameters</span>
        </v-tooltip>
      </div>
      <v-card flat class="custom-shadow mb-5 mt-2">
        <v-card-text>
          <v-card flat color="#eef6ff">
            <v-card-text class="d-flex justify-space-between align-center">
                <div>
                  <h5 class="titleText--text ml-1 mb-2">Dependent variable</h5>
                  <v-select
                    v-model="selectedmodeldepvarlist"
                    :items="ItemListmodeldepvarlist"
                    hide-details="auto"
                    placeholder="select variables"
                    solo
                    flat
                    class="custom-shadow"
                  ></v-select>
                </div>
                <div class="mt-8">
                  <v-icon color="titleText" large>mdi-equal</v-icon>
                  <v-icon color="titleText" large>mdi-function</v-icon>
                </div>
                <div>
                  <h5 class="titleText--text ml-1 mb-2">
                    Independent variable
                  </h5>
                  <v-select
                    multiple
                    v-model="selectedmodelindepvarlist"
                    :items="ItemListmodelindepvarlist"
                    hide-details="auto"
                    placeholder="select variables"
                    solo
                    full-width
                    style="width: 50vw"
                    flat
                    class="custom-shadow"
                  >
                    <template v-slot:prepend-item>
                      <v-text-field 
                      v-model="searchTerm"
                      placeholder="Search"
                      @input="searchItems"
                      hide-details
                      dense
                      clearable
                      flat
                      solo
                      solo-filled
                      prepend-inner-icon="mdi-magnify"
                      />
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-chip
                        small
                        close
                        dark
                        color="blue"
                        class="font-weight-bold"
                        @click:close="removeSelectesVariable(item)"
                        >
                        <span class="font-weight-bold">{{ item }}</span>
                      </v-chip
                      >
                    </template>
                  </v-select>
                </div>
                <div class="d-flex mt-8">
                  <v-btn
                    title="Select Base & Increment Variables"
                    @click="OpenVarGroup()"
                    icon
                    color="titleText"
                    class="mr-3"
                  >
                    <v-icon
                      color="titleText"
                      title="Select Base & Increment Variables"
                      >mdi-cog-outline</v-icon
                    >
                  </v-btn>
                  <v-btn
                    title="Run the Model"
                    right
                    depressed
                    class="blue"
                    height="42"
                    @click="GetDataClick()"
                  >
                    <v-icon color="white" class="ml-0 mr-3" right dark>
                      mdi-rocket-launch
                    </v-icon>
                    <span class="font-weight-bold text-capitalize white--text"
                      >Run The Model</span
                    >
                  </v-btn>
                </div>
            </v-card-text>
          </v-card>
          <div class="d-flex justify-space-between mt-5">
            <RSQUAREDiv
              ref="refrsquardiv"
              :divdata="this.ItemDataForStats"
            ></RSQUAREDiv>
            <ADRJDiv
              ref="refADRJDiv"
              :divdata="this.ItemDataForStats"
            ></ADRJDiv>
            <MAPDiv ref="refMAPDiv" :divdata="this.ItemDataForStats"></MAPDiv>
            <DWdiv ref="refDWdiv" :divdata="this.ItemDataForStats"></DWdiv>
            <AICDiv ref="refAICDiv" :divdata="this.ItemDataForStats"></AICDiv>
            <BICDiv ref="refBICDiv" :divdata="this.ItemDataForStats"></BICDiv>
          </div>
        </v-card-text>
      </v-card>
      <div>
        <div class="d-flex">
          <h2 class="titleText--text">Model estimates</h2>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  v-bind="attrs" size="medium"
              v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
            </template>
            <span> Variable execution over time</span>
          </v-tooltip>
        </div>
        <v-card flat class="custom-shadow mb-5 mt-2">
          <v-card-text>
            <div class="d-flex justify-center" v-if="!isItemListmodeldatacount">
              <v-progress-circular indeterminate size="50" color="blue" />
            </div>
            <v-simple-table v-else fixed-header max-height="600">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="grey-bg"></th>
                    <th
                      class="text-left titleText--text font-weight-bold grey-bg"
                    >
                      Variable Name
                    </th>
                    <th
                      class="text-center titleText--text font-weight-bold grey-bg"
                    >
                      {{ "Region" | tableheader }}
                    </th>
                    <th
                      class="text-center titleText--text font-weight-bold grey-bg"
                    >
                      Coefficient
                    </th>
                    <th
                      class="text-center titleText--text font-weight-bold grey-bg"
                    >
                      {{ "Standard Error" | tableheader }}
                    </th>
                    <th
                      class="text-center titleText--text font-weight-bold grey-bg"
                    >
                      tValue
                    </th>
                    <th class="text-center blue--text font-weight-bold blue-bg">
                      Previous Coefficient
                    </th>
                    <th class="text-center blue--text font-weight-bold blue-bg">
                      Coefficient Difference
                    </th>
                    <th class="text-center blue--text font-weight-bold blue-bg">
                      Previous tValue
                    </th>
                    <th class="text-center blue--text font-weight-bold blue-bg">
                      tValue Difference
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in ItemListmodeldata" :key="item">
                    <td class="text-center grey-bg" title="Lock Variable Volume">
                      <v-btn
                        v-if="item.rowid > 1"
                        center
                        depressed
                        height="26"
                        x-small
                        color="blue"
                        dark
                        @click="
                          frezzClick(
                            item.rowid,
                            item.Variable_Name,
                            item.region,
                            item.Coefficient,
                            item.tValue
                          )
                        "
                      >
                        <v-icon small> mdi-lock </v-icon>
                      </v-btn>
                    </td>
                    <td
                      class="text-left font-weight-bold titleText--text grey-bg"
                    >
                      <!--<div
                            v-if="item.rowid > 1"
                            title="Click here to show details"
                            @click="clickShowCoffData(item.Variable_Name)"
                            style="cursor: pointer"
                          >-->
                      <div v-if="item.rowid > 1">
                        {{ item.Variable_Name }}
                      </div>
                      <div v-else>{{ item.Variable_Name }}</div>
                    </td>
                    <td class="text-center darkGrey--text grey-bg">
                      {{ item.region }}
                    </td>
                    <td class="text-right darkGrey--text grey-bg">
                      {{ String(item.Coefficient) | trgm_numberformatenew }}
                    </td>
                    <td class="text-right darkGrey--text grey-bg">
                      {{ formatedatavalue(String(item.Standard_Error)) }}
                    </td>
                    <td class="text-right darkGrey--text grey-bg">
                      {{ formatedatavalue(String(item.tValue)) }}
                    </td>
  
                    <td class="blue-bg text-right darkGrey--text">
                      {{ item.Previous_Coefficient || 0 }}
                    </td>
                    <td class="blue-bg text-right darkGrey--text">
                      {{ item.Coefficient_Difference || 0 }}
                    </td>
                    <td class="blue-bg text-right darkGrey--text">
                      {{ item.Previous_tValue || 0 }}
                    </td>
                    <td class="blue-bg text-right darkGrey--text">
                      {{ item.tValue_Difference || 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="titleText--text font-weight-bold"
                      colspan="11"
                      left
                    >
                      Offset Variables of the Model
                    </td>
                  </tr>
                  <tr v-for="item in ItemListmodeloffsetdata" :key="item">
                    <td
                      class="text-center grey-bg"
                      title="Unlock Variable Volume"
                    >
                      <v-btn
                        center
                        x-small
                        depressed
                        height="26"
                        color="red"
                        dark
                        @click="
                          unfrezzClick(
                            item.variable,
                            item.region,
                            item.coeff,
                            item.tvalue
                          )
                        "
                      >
                        <v-icon small center dark>mdi-lock-open </v-icon>
                      </v-btn>
                    </td>
                    <td
                      class="text-left titleText--text font-weight-bold grey-bg"
                    >
                      <div
                        title="Click here to show details"
                        @click="clickShowCoffData(item.variable)"
                        style="cursor: pointer"
                      >
                        {{ item.variable }}
                      </div>
                    </td>
                    <td class="text-center darkGrey--text grey-bg">national</td>
                    <td class="text-center darkGrey--text grey-bg">
                      <div
                        title="Click here to edit coeffcient"
                        @click="clickShowCoffData(item.variable)"
                        style="cursor: pointer"
                      >
                        {{ String(item.coeff) | trgm_numberformate }}
                      </div>
                    </td>
                    <!-- <td class="text-right darkGrey--text grey-bg">
                      <v-edit-dialog
                        :return-value.sync="item.coeff"
                        @cancel="cancel"
                        @open="open"
                        @close="close"
                        @save="
                          frezzClick(
                            item.rowid,
                            item.variable,
                            item.region,
                            item.coeff,
                            item.tvalue
                          )
                        "
                        large
                      >
                      
                        {{ String(item.coeff) | trgm_numberformate }}
                        <template v-slot:input>
                          <v-text-field
                            v-model="item.coeff"
                            label="Edit"
                            single-line
                            class="text-center"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>-->
                    <td class="grey-bg"></td>
                    <td class="text-right darkGrey--text grey-bg">
                      {{ formatedatavalue(String(item.tValue)) }}
                    </td>
  
                    <td class="blue-bg"></td>
                    <td class="blue-bg"></td>
                    <td class="blue-bg"></td>
                    <td class="blue-bg"></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
      <modelmixchart ref="refmodelmixchart"></modelmixchart>
      <modelAreaChart ref="refmodelAreaChart" class="mt-5"></modelAreaChart>
      <!-- <v-row>
          <v-col>
            <v-expansion-panels multiple v-model="colaps3">
              <v-expansion-panel @click="onExpansionPanelClick">
                <v-expansion-panel-header>
                  Actual Volume vs Predicted Volume
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <v-row>
                    <v-col>
                      <modelmixchart ref="refmodelmixchart"></modelmixchart>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <modelAreaChart ref="refmodelAreaChart"></modelAreaChart>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row> -->
    </div>
    <div v-if="bttype === 3" class="container--fluid" eager>
      <ctrlModelOutCome ref="ctrlmodeloutcome" eager></ctrlModelOutCome>
      <v-btn
        bottom
        right
        dark
        flat
        fixed
        color="blue"
        class="mb-5 font-weight-bold text-capitalize"
        @click="SaveModelOutCome()"
      >
        Save Model
      </v-btn>
    </div>
    <div v-if="bttype === 4" class="container--fluid" eager>
      <CtrlSynergyActivities
        ref="ctrlSynergyActivities"
        eager
      ></CtrlSynergyActivities>
    </div>
    <CoffDatatable ref="ctrlcoffdatatable"></CoffDatatable>
    <CtrlCoffOffsetData ref="ctrlcoffoffsetdata"></CtrlCoffOffsetData>
    <CtrlVarGrp ref="ctrlvargroup"></CtrlVarGrp>
    <CtrlModelDataRegionWise
      ref="ctrlmodeldataregionwise"
    ></CtrlModelDataRegionWise>
    <CtrlModelDataRegionWiseMap
      ref="ctrlmodeldataregionwisemap"
    ></CtrlModelDataRegionWiseMap>
    
  </v-container>
</template>

<script>
//import { bus } from "../../../main";
import numeral from "numeral";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
//import ctrlplotArea from "./Plots.vue";
import ctrlModelOutCome from "./ModelOutCome.vue";
import AuthCtrl from "../../../components/AuthAction.vue";
//import AppWidget from "../../../../components/AppWidget.vue";
import apifactory from "../api";
import apifactorygobal from "../../../apis/apifactory";
import modelmixchart from "./ModelMixChart.vue";
import modelAreaChart from "./ModelAreaChart.vue";
import ADRJDiv from "./ModelADRJDiv.vue";
import DWdiv from "./ModelDWdiv.vue";
import MAPDiv from "./ModelMAPDiv.vue";
import AICDiv from "./ModelAICdiv.vue";
import BICDiv from "./ModelBICdiv.vue";
import RSQUAREDiv from "./ModelRSQUAREDiv.vue";
import CoffDatatable from "./coffdata.vue";
import globalclass from "../../../global/globalvar";
import globalstorage from "../../../global/GlobalStrorage";
//import CtrlNavButton from "../../../components/CtrbuttonSaveAndNext.vue";
import CtrlVarGrp from "./Ctrlvargrp.vue";
import CtrlModelDataRegionWise from "./CtrlModelDataRegionwise.vue";
import CtrlModelDataRegionWiseMap from "./CtrlModelDataRegionwiseMap.vue";
import CtrlCoffOffsetData from "./coffoffsetdata.vue";
import CtrlSynergyActivities from "./SynergyActivities/SynergyActivitiesViewModel.vue";
//import CtrlNewLook from "./DashboardStatisticsCard.vue";
Vue.use(VueAxios, axios);
export default {
  components: {
    //plotArea: ctrlplotArea,
    CtrlSynergyActivities,
    ctrlModelOutCome,
    modelmixchart,
    modelAreaChart,
    ADRJDiv,
    DWdiv,
    MAPDiv,
    RSQUAREDiv,
    CoffDatatable,
    //,dwdata
    AuthCtrl,
    AICDiv,
    BICDiv,
    // CtrlNavButton,
    CtrlVarGrp,
    CtrlModelDataRegionWise,
    CtrlCoffOffsetData,
    CtrlModelDataRegionWiseMap,
  },
  data: () => ({
    headerTitleIocn: globalclass.ICON_BuildtheModel,
    projectid: "",
    projectname: globalstorage.getProjectName(),
    ItemListmodeldata: [],
    isItemListmodeldatacount: false,
    ItemListmodeldepvarlist: [],
    ItemListmodelindepvarlist: [],
    ItemListmodeloffsetdata: [],

    selectedmodelindepvarlist: [],
    selectedmodeldepvarlist: [],

    panelfirst: 0,
    panelsecond: 0,

    parmforsave: [],

    bttype: 1,

    colaps1: [],
    colaps2: [],
    colaps3: [],

    dataregion: [],
    dataregionSelected: [],
    searchTerm: '',
    copiedItems: [],

    mixchartdata: [],
    modeldatafull: [],
    ItemDataForStats: [],

    //region
    listofregion: [],
    isregiosubnnational: false,
    //offsetdata
    offset_params_data: [],
    offset_params_data_filter: [],
  }),
  methods: {
    removeSelectesVariable (value) {
      this.selectedmodelindepvarlist = this.selectedmodelindepvarlist.filter(item => value !== item)
    },
    searchItems() {
      if (!this.searchTerm) {
        this.ItemListmodelindepvarlist = [...this.copiedItems]
      }

      this.ItemListmodelindepvarlist = this.copiedItems.filter((item) => {
        return item.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    filteroffsetdata(varvaiablename) {
      //alert(varvaiablename);
      this.offset_params_data_filter = this.offset_params_data.filter(
        (a) => a.variable == varvaiablename
      );
      this.$refs.ctrlcoffoffsetdata.Refresh(
        varvaiablename,
        this.offset_params_data_filter
      );
    },
    OpenVarGroup() {
      this.$refs.ctrlvargroup.OnloadCall();
    },
    OpenCtrlModelDataRegionWise() {
      this.$refs.ctrlmodeldataregionwise.OnloadCall(
        this.modeldatafull,
        this.dataregion
      );
    },
    OpenCtrlModelDataRegionWiseMap() {
      this.$refs.ctrlmodeldataregionwisemap.OnloadCall(
        this.modeldatafull,
        this.dataregion
      );
    },
    onExpansionPanelClick(event) {
      if (event.target.classList.contains("v-expansion-panel-header--active")) {
        alert("Panel is closing/now closed.");
      } else {
        //alert(this.mixchartdata.length);
        if (this.mixchartdata.length > 0) {
          //alert("Panel is opening/now open.");
          //alert(JSON.stringify(this.mixchartdata));
          //this.$refs.refmodelmixchart.onloadgotchart(this.mixchartdata,'national');
          this.$refs.refmodelmixchart.onloadgotchart();
          this.$refs.refmodelAreaChart.Refresh();
        }
        // this.$refs.refmodelmixchart.Refresh();
        //bus.$emit('refreshmodelmixchart');
      }
    },
    onBackclick() {
      this.$router.push("/variabletransformation");
    },
    onclickbtn(varbttype) {
      //alert(varbttype);
      this.bttype = varbttype;
      if (varbttype === 4) {
        //this.onPreviewclick();
        this.$refs.ctrlSynergyActivities.callfromParent();
      }
      if (varbttype === 3) {
        this.$refs.ctrlmodeloutcome.loaddataOnChild();
        //this.onPreviewclick();
      }
      if (varbttype === 2) {
        //this.onPreviewclick();
      }
      if (varbttype === 1) {
        //this.onPreviewclick();
      }
    },
    // eslint-disable-next-line no-unused-vars
    frezzClick(rowid, variable, group, coeff, tratio) {
      //alert(this.selectedmodelindepvarlist.length);
      if (this.selectedmodelindepvarlist.length > 1) {
        let temparray = "";
        this.parmforsave = [];
        for (var k = 0; k < this.selectedmodelindepvarlist.length; k++) {
          //alert(this.selectedmodelindepvarlist[k]);
          if (this.selectedmodelindepvarlist[k] != variable) {
            temparray = temparray + this.selectedmodelindepvarlist[k] + ",";
          }
        }
        //temparray=temparray.splice((temparray.length -1), 1);
        let obj = new Object();
        obj.y = this.selectedmodeldepvarlist;
        obj.x = temparray.substring(0, temparray.length - 1);
        this.parmforsave.push(obj);
        // alert(JSON.stringify(this.parmforsave).length);
        this.parmforsave = this.parmforsave[0];
        this.modelsaveoffset(variable, group, coeff, tratio);

        // this.modelsave();

        //  this.getmodeldepvarlist();

        //this.getmodeloffsetdata();
      }
    },
    unfrezzClick(variable, group, coeff, tratio) {
      apifactory
        .api_get_model_save_offset_remove(variable, group, coeff, tratio)
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.binddataAgain();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    //

    SaveModelOutCome() {
      apifactory
        .api_save_model_final()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.binddataAgain();
            this.FinalUpdateProject();
            // alert('Save');
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    FinalUpdateProject() {
      apifactory
        .api_save_project_complete()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.binddataAgain();
            alert("Save");
            window.location.reload();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    /*frezzClick(rowid, variable, group, coeff, tratio) {

            this.modelsaveoffset(variable, group, coeff, tratio);
        },*/
    GetDataClick() {
      //this.getmodeldata();
      //alert("GetDataClick");
      if (this.selectedmodelindepvarlist.length > 0) {
        let temparray = "";
        this.parmforsave = [];
        for (var k = 0; k < this.selectedmodelindepvarlist.length; k++) {
          temparray = temparray + this.selectedmodelindepvarlist[k] + ",";
          // temparray.push(this.selectedmodelindepvarlist[k]);
        }
        //temparray=temparray.splice((temparray.length -1), 1);
        let obj = new Object();
        obj.y = this.selectedmodeldepvarlist;
        obj.x = temparray.substring(0, temparray.length - 1);
        this.parmforsave.push(obj);
        // alert(JSON.stringify(this.parmforsave).length);
        this.parmforsave = this.parmforsave[0];
        this.modelsave();
      }
    },

    getmodeldata() {
      this.ItemListmodeldata = [];
      this.isItemListmodeldatacount = false;
      this.modeldatafull = [];
      apifactory
        .api_get_model_data()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.modeldatafull = res.data;
            let temlist = [];
            temlist = res.data.coefficients_table;
            this.ItemListmodeldata = temlist.filter(
              (a) => a.region == "national"
            );
            // this.ItemListmodeldata.filter(a=>a.region == national);
            let indexno = 1;
            for (var k = 0; k < this.ItemListmodeldata.length; k++) {
              this.ItemListmodeldata[k].rowid = indexno;
              indexno = indexno + 1;
            }
            if (this.ItemListmodeldata.length > 0) {
              this.isItemListmodeldatacount = true;
            }
            let temlistdivs = [];
            temlistdivs = res.data.model_statistics;
            this.ItemDataForStats = temlistdivs;
            this.$refs.refrsquardiv.divdata = this.ItemDataForStats;
            this.$refs.refADRJDiv.divdata = this.ItemDataForStats;
            this.$refs.refMAPDiv.divdata = this.ItemDataForStats;
            this.$refs.refDWdiv.divdata = this.ItemDataForStats;
            this.$refs.refAICDiv.divdata = this.ItemDataForStats;
            this.$refs.refBICDiv.divdata = this.ItemDataForStats;
            // let temlistmixchart = [];
            //temlistmixchart = res.data.actual_predicted_chart;
            this.mixchartdata = res.data.actual_predicted_chart;

            //onloadgotchart

            //this.$refs.refrsquardiv.divdata='manish';
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getmodeldepvarlist() {
      this.ItemListmodeldepvarlist = [];
      this.ItemListmodelindepvarlist = [];
      this.dataregion = [];
      apifactory
        .api_get_model_dep_varlist()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.ItemListmodeldepvarlist = res.data.dependent_var_list; //[...Object.keys(res.data.dependent_var_list)];
            this.ItemListmodelindepvarlist = res.data.independent_var_list;
            this.copiedItems = [...this.ItemListmodelindepvarlist]
            this.dataregion = res.data.region_list;
            this.getmodeldepvarlist_saved();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getmodeldepvarlist_saved() {
      this.selectedmodelindepvarlist = [];
      this.selectedmodeldepvarlist = [];

      apifactory
        .api_get_save_model_params()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            let templist = res.data.model_defns.x;
            //alert( JSON.stringify(templist.split(',')));
            this.selectedmodelindepvarlist = templist.split(","); //[...Object.keys(res.data.dependent_var_list)];
            this.selectedmodeldepvarlist = res.data.model_defns.y;
            //alert(JSON.stringify(templist));
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getmodelindepvarlist_tbd() {
      this.ItemListmodelindepvarlist = [];
      apifactory
        .get_model_indep_varlist()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.ItemListmodelindepvarlist = [...Object.keys(res.data)];
            this.copiedItems = [...this.ItemListmodelindepvarlist]
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    modelsave() {
      apifactory
        .api_get_model_save(JSON.stringify(this.parmforsave))
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.addeventsAndCall();
            this.getmodeldata();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    addeventsAndCall() {
      /* bus.$emit('refreshADRJData');
            bus.$emit('refreshdwdata');
            bus.$emit('refreshMAPEData');
            bus.$emit('refreshRsquareddata');
            bus.$emit('refreshmodelmixchart');
            bus.$emit('refreshmodelAreaChart');*/
      this.$refs.refmodelmixchart.onloadgotchart();
      this.$refs.refmodelAreaChart.Refresh();
      //alert("refrsquardiv");
      //modelmixchart
    },
    modelsaveoffset(variable, group, coeff, tratio) {
      // apifactory.get_model_save_offset(variable, group, coeff, tratio)
      apifactory
        .api_get_model_save_offset(variable, group, coeff, tratio)
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.modelsave();

            this.getmodeldepvarlist();

            this.getmodeloffsetdata();
            //this.binddataAgain();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getmodeloffsetdata() {
      this.ItemListmodeloffsetdata = [];

      apifactory
        .api_get_model_offset_saved()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            if (res.data.status != 204) {
              //alert(JSON.stringify(res.data.offset_params));
              this.offset_params_data = res.data.offset_params;
              //this.ItemListmodeloffsetdata = res.data.offset_params;
              let resultgroup = this.groupBy(
                res.data.offset_params.filter((a) => a.region == "national"),
                "variable"
              );
              //alert(JSON.stringify(resultgroup));
              //this.ItemListmodeloffsetdata = resultgroup;
              let grouplist = [];
              grouplist = resultgroup;
              // alert(JSON.stringify(grouplist));
              let newitemlist = [];
              let indexno = 1;
              for (let element in grouplist) {
                grouplist[element][0].rowid = indexno;
                grouplist[element][0].Standard_Error = "";
                newitemlist.push(grouplist[element][0]);
                //alert(JSON.stringify(grouplist[element]));
                //  alert(JSON.stringify(this.grouplist[element]));
                indexno = indexno + 1;
              }
              //alert(JSON.stringify(newitemlist));
              this.ItemListmodeloffsetdata = newitemlist;
              /*
                            let indexno = 1;
                            for (var k = 0; k < this.ItemListmodeloffsetdata.length; k++) {
                                alert(JSON.stringify(this.ItemListmodeloffsetdata[0]));
                                this.ItemListmodeloffsetdata[0][k].rowid = indexno;
                                this.ItemListmodeloffsetdata[0][k].Standard_Error = '';
                                indexno = indexno + 1;
                            }*/
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    formatedatavalue(value) {
      let newval = String(value);
      let temarray = newval.split(".");
      let formatestr = numeral(temarray[0]).format("0,0");
      let result = formatestr;
      if (temarray.length > 1) {
        result = result + "." + temarray[1];
      }

      return `${result}`;
    },
    getselectedmodelindepvarlist() {
      let tempdata = [];
      let tempdatax = [];
      this.selectedmodelindepvarlist = [];
      apifactory
        .get_model_params_alreadysaved()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            tempdata = res.data;
            //alert(JSON.stringify(tempdata));
            //alert(JSON.stringify(tempdata.y));
            // alert(JSON.stringify(tempdata.x));
            this.selectedmodeldepvarlist = tempdata.y;
            tempdatax = tempdata.x;
            //alert(tempdatax);
            let arrayitem = [];
            // alert(tempdatax.split(',')[0]);
            arrayitem = tempdatax.split(",");
            // let newselect=[];

            for (var k = 0; k < arrayitem.length; k++) {
              //alert(arrayitem[k]);
              this.selectedmodelindepvarlist.push(arrayitem[k]);
            }
            //alert(newselect);

            // this.selectedmodelindepvarlist = res.data.x;
            //this.GetDataClick();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getprojectregions() {
      //this.listofregion = [];
      apifactorygobal.api_get_project_region_list().then((res) => {
        if (res.status != 200) {
          // return false;
        } else {
          if (res.data.length == 0) {
            this.isregiosubnnational = false;
            //this.listofregion.push("national");
            //this.dataregionSelected = this.listofregion[0];
          } else {
            this.isregiosubnnational = true;
            //this.listofregion = res.data.filter((a) => a != "national");
            //this.dataregionSelected = this.listofregion[0];
          }
          //this.dataregion = this.listofregion;
          //alert('data:-'+this.listofregion.length);
        }
      });
    },
    binddataAgain() {
      //alert('call');
      this.getmodeldepvarlist();
      // this.getmodelindepvarlist();
      //this.getselectedmodelindepvarlist();
      //this.GetDataClick();
      this.getmodeldata();
      this.getmodeloffsetdata();
      //this.getcurrentproject();
    },
    clickShowCoffData(varname) {
      //alert('hi'+varname);
      this.filteroffsetdata(varname);
      // this.$refs.ctrlcoffdatatable.Refresh(varname);

      //bus.$emit("coffdatavuewrefresh", varname);
    },
    savestep() {},
  },
  mounted() {
    this.getprojectregions();
    this.binddataAgain();
  },
  computed: {
    getsplitstring(value) {
      // let myNumeral = numeral(1000);
      let tempstring = value; //'-70738.5666';
      // let formatestr=numeral(tempstring.split('.')[0]).format('0,0');
      let formatestr = numeral(tempstring).format("0,0");
      let result = formatestr + "." + tempstring.split(".")[1];
      return result;
    },
    formatenumberdata: function (value) {
      //alert(value);
      // let myNumeral = numeral(1000);
      //let tempstring = '70738.5666';
      // alert(parseInt(value));
      /* let newarray=[];
             newarray=String(value).split('.');
             alert(newarray);*/
      let tempstring = String(value); // "-70738.5666";
      //let formatestr = numeral(tempstring.split('.')[0]).format('0,0');
      // let formatestr = numeral(tempstring).format("0,0");
      // let result = formatestr + "." + tempstring.split(".")[1];
      // let result = tempstring.split(".")[1];
      //alert(result);
      return tempstring;
    },
    checkhavedata() {
      let havedata = false;
      if (this.mixchartdata.length > 0) {
        havedata = true;
      }
      return havedata;
    },
    issubnationdata() {
      let itemvalue = "";
      itemvalue = this.dataregion.length;
      if (itemvalue > 1) return true;
      else return false;
      //return itemvalue;
    },
  },
  watch: {
    bttype: function (val) {
      if (val == 1) {
        //alert(this.mixchartdata.length);
        if (this.mixchartdata.length > 0) {
          //alert("done");
          this.$refs.refmodelmixchart.getplot();
        }
      }
    },
  },
};
</script>

<style scoped>
.tabletitle {
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  /*margin-left: 10px;*/
}

.blue-bg {
  background-color: rgb(81, 167, 248, 0.1) !important;
  color: white;
}

.selectedbtn {
  background-color: #0023f4 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.customselectbox {
  padding-top: 10px !important;
  width: 80% !important;
}

.grey-bg {
  background: rgb(243, 245, 248, 0.4) !important;
}

table td {
  border: none !important;
}

table thead,
table tr {
  border: none !important;
}
.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}
.runmodelbtn {
  background: linear-gradient(90deg, #f46b45 0%, #eea849 100%);
  color: white;
}
.savemodel {
  background: linear-gradient(90deg, #f46b45 0%, #eea849 100%);
}
</style>
